import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const PositionListing = ({ positions, removePosition }) => {
    return (<Table className='margin-table table-responsive-lg'>
        <thead className='pos-list-header'>
            <tr>
                <th>Exchange</th>
                <th>Product</th>
                <th>Ticker</th>
                <th>Expiry</th>
                <th>Option</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>{' '}</th>
            </tr>
        </thead>
        <tbody>
            {positions.map((e, i) => (
                <tr key={i}>
                    <td>{e.exchange}</td>
                    <td>{e.product}</td>
                    <td>{e.ticker}</td>
                    <td>{e.expiry}</td>
                    <td>{e.option}</td>
                    <td>{e.qty}</td>
                    <td>{e.price}</td>
                    <td> <FontAwesomeIcon icon={faTrash} onClick={() => { removePosition(e.exInstrumentId)}} />
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>);
}

export default PositionListing;